export default __webpack_public_path__ + "static/media/refresh.1d51dc8e.svg";